import ArrowDownward from '@mui/icons-material/ArrowDownward'
import ArrowForward from '@mui/icons-material/ArrowForward'
import ArrowUpward from '@mui/icons-material/ArrowUpward'
import { Skeleton, Stack, Tooltip, TooltipProps, Typography } from '@mui/material'
import { FC } from 'react'

type Props = {
  title?: string
  count?: number | null
  changeRate?: number | null
  /** 最古日の値が0などで成長率を算出できない場合に「—」を表示 */
  changeRateUnavailable?: boolean
  changeRateTooltipTitle?: string
  loading?: boolean
}

const MaybeTooltip = ({
  title,
  ...props
}: Omit<TooltipProps, 'title'> & {
  title?: TooltipProps['title']
}) => (title ? <Tooltip {...props} title={title} /> : <>{props.children}</>)

const MaybeLoading = ({ loading, children }: { loading?: boolean; children: React.ReactNode }) =>
  loading ? <Skeleton>{children}</Skeleton> : <>{children}</>

export const CompanyInstagramInsightCount: FC<Props> = ({
  title,
  count,
  changeRate,
  changeRateUnavailable,
  changeRateTooltipTitle,
  loading,
}) => {
  return (
    <Stack gap={1}>
      <MaybeLoading loading={loading}>
        <Typography component="span" fontSize={14} sx={{ color: '#343434' }}>
          {loading ? 'xxxxxxxx' : title}
        </Typography>
      </MaybeLoading>
      <Stack direction="row" alignItems="flex-end" gap={2}>
        <MaybeLoading loading={loading}>
          <Typography
            component="span"
            fontSize={48}
            display="flex"
            fontWeight="bold"
            sx={{
              lineHeight: 1.1,
              mb: -1,
              color: '#343434',
            }}
          >
            {loading ? 'xxx' : typeof count === 'number' ? count : `--`}
          </Typography>
        </MaybeLoading>
        {!loading && (typeof changeRate === 'number' || changeRateUnavailable) && (
          <MaybeTooltip title={changeRateTooltipTitle} placement="top" arrow>
            <Typography
              component="span"
              fontSize={26}
              fontWeight="bold"
              display="flex"
              alignItems="center"
              sx={{
                borderBottom: changeRateTooltipTitle ? '1px dotted #808080' : undefined,
                color: changeRateUnavailable
                  ? '#666666'
                  : changeRate === 0
                    ? '#666666'
                    : (changeRate ?? 0) > 0
                      ? '#4B7B0E'
                      : '#A90000',
                lineHeight: 1.2,
              }}
            >
              {changeRateUnavailable ? (
                '—%'
              ) : (
                <>
                  {changeRate === 0 ? (
                    <ArrowForward fontSize="inherit" />
                  ) : (changeRate ?? 0) > 0 ? (
                    <ArrowUpward fontSize="inherit" />
                  ) : (
                    <ArrowDownward fontSize="inherit" />
                  )}
                  {changeRate}%
                </>
              )}
            </Typography>
          </MaybeTooltip>
        )}
      </Stack>
    </Stack>
  )
}
